const LINK_GROUPS = [
  {
    title: "栏目",
    links: ["联动瓜", "跨界小料", "串门动态", "跨圈追踪", "圈外爆料"],
  },
  {
    title: "吃瓜指南",
    links: ["理清关系", "判断可信度", "文明吃瓜", "后续跟进"],
  },
];

const CHANNELS = [
  { icon: "ri-wechat-line", label: "公众号" },
  { icon: "ri-twitter-x-line", label: "微博" },
  { icon: "ri-play-circle-line", label: "哔哩哔哩" },
  { icon: "ri-message-3-line", label: "豆瓣" },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="container-x grid grid-cols-1 gap-8 py-10 sm:grid-cols-2 md:py-14 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <a href="#top" className="flex items-center gap-2.5" aria-label="71吃瓜">
            <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-primary-500 text-xl text-background-50">
              <i className="ri-vip-crown-2-fill" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-display text-2xl text-background-50">
                71<span className="text-primary-400">吃瓜</span>
              </span>
              <span className="mt-1 text-[11px] tracking-wide text-background-300">
                联动 · 串门 · 跨圈小料一条线
              </span>
            </span>
          </a>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
            71吃瓜专注跨圈联动、跨界合作与串门互动的内容整理，把来路、影响与后续更新收在同一条线上，陪你边吃边理清关系。
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            {CHANNELS.map((c) => (
              <a
                key={c.label}
                href="#about"
                className="flex items-center gap-2 whitespace-nowrap rounded-full border border-background-700 px-3.5 py-2 text-sm text-background-200 transition-colors hover:border-primary-400 hover:text-primary-300"
              >
                <i className={c.icon} /> {c.label}
              </a>
            ))}
          </div>
        </div>

        {LINK_GROUPS.map((g) => (
          <nav key={g.title} aria-label={g.title}>
            <h3 className="font-medium text-background-100">{g.title}</h3>
            <ul className="mt-4 space-y-2.5">
              {g.links.map((l) => (
                <li key={l}>
                  <a
                    href="#top"
                    className="text-sm text-background-300 transition-colors hover:text-primary-300"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>

      <div className="border-t border-background-800">
        <div className="container-x flex flex-col items-center justify-between gap-2 py-5 text-xs text-background-400 sm:flex-row">
          <p>© {new Date().getFullYear()} 71吃瓜 · 内容整理平台</p>
          <p className="flex flex-wrap items-center gap-3">
            <span>联系：hello@71chigua.example.com</span>
            <a href="#about" className="hover:text-primary-300">
              免责与投稿说明
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}